/* eslint-disable */
export default {
  close: 'Close',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
